<template>
    <div
        class="max-w-7xl mx-auto py-6 px-4 sm:py-8 sm:px-6 lg:px-8 text-center"
    >
        <div class="flex justify-center items-center flex-wrap">
            <span
                class="shrink-0 inline-flex items-center justify-center h-10 w-10 sm:h-16 sm:w-16 rounded-md bg-nutreance-green text-white mr-4"
            >
                <svg-vue
                    class="h-7 w-7 sm:h-12 sm:w-12 text-nutreance-green"
                    :icon="productCategory.svg"
                />
            </span>

            <h1
                class="mt-1 text-3xl font-bold text-gray-900 sm:tracking-tight lg:text-4xl"
            >
                {{ productCategory.name }}
            </h1>
        </div>

        <h2 class="max-w-3xl mt-5 mx-auto text-lg lg:text-xl text-gray-700">
            {{ productCategory.description }}
        </h2>
    </div>
</template>

<script setup lang="ts">
import { inject, onMounted, ref } from "vue";
import type { AppEmitter } from "../../emitter";

const props = defineProps<{
    initialProductCategory?: any;
}>();

const emitter = inject<AppEmitter>("mitt")!;
const productCategory = ref(props.initialProductCategory);

onMounted(() => {
    emitter.on("productCategoryUpdated", (newProductCategory: any) => {
        if (!newProductCategory?.slug) {
            return;
        }

        productCategory.value = newProductCategory;
        window.history.pushState(
            {},
            "",
            `/product-categories/${newProductCategory.slug}`,
        );
    });
});
</script>
